import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_two_wrap" }

import { ref } from 'vue';
    import { useStore } from 'vuex';
    import { getNewsContentList } from '@/config/request';
    import LeftMenu from './left-menu/index.vue'
    import RightCont from './right-cont/index.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    let content = ref('') as any  //  点击左侧菜单右边展示的详情
    const clickEven=(val:string)=>{
        content.value = val
    }


    let newsTypeId = ref('') //  新闻类型id
    let newsList = ref([]) as any   //  新闻列表
    let leftMenuStatus = ref(false)

    const store = useStore()

    const init = async() => {
        const newsTypeList = await store.dispatch('getNewsType') as any
        newsTypeList.forEach((res:any)=>{
            if(res.themeName === '走进自贸区'){
                newsTypeId.value = res.id
                return false
            }
        })
        getNewsList()
    }
    const getNewsList = async() => {
        const param = {
            themeId: newsTypeId.value
        }
        const res = await getNewsContentList(param) as any
        if(res.result?.records.length > 6){
            newsList.value = res.result?.records.slice(0,6)
        }else{
            newsList.value = res.result?.records
        }
        leftMenuStatus.value = true
        content.value = newsList.value[0]
    }

    init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
          _createElementVNode("span", null, "首页"),
          _createTextVNode(),
          _createElementVNode("i", null, ">"),
          _createTextVNode(),
          _createElementVNode("span", null, "走进自贸区")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_unref(leftMenuStatus))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_unref(leftMenuStatus))
                  ? (_openBlock(), _createBlock(LeftMenu, {
                      key: 0,
                      onClickChild: clickEven,
                      newsList: _unref(newsList)
                    }, null, 8, ["newsList"]))
                  : _createCommentVNode("", true),
                _createVNode(RightCont, { content: _unref(content) }, null, 8, ["content"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})